import { Type } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
export var SwapOperation;
(function (SwapOperation) {
    SwapOperation["Buy"] = "buy";
    SwapOperation["Sell"] = "sell";
})(SwapOperation || (SwapOperation = {}));
export const SwapOperationSchema = Type.Enum(SwapOperation);
/**
 * Parses a string into a SwapOperation enum value
 * @param operation - The operation string to parse ('buy' or 'sell')
 * @returns The parsed SwapOperation value
 * @throws {Error} If the operation string is invalid
 */
export const parseSwapOperation = (operation) => {
    try {
        return Value.Parse(SwapOperationSchema, operation);
    }
    catch {
        throw new Error(`Invalid swap operation: ${operation}. Expected 'buy' or 'sell'.`);
    }
};
//# sourceMappingURL=swap-operation.js.map